import * as React from "react"
import { Block } from "../../../custom_components/components/library/container"
import { Link } from "../../../custom_components/components/library/link"
import { trackNewsletterSubscription } from "../../../custom_components/components/library/tracking"
import { Loader } from "../../../custom_components/components/loader"
import { NewsletterFormBlockProps } from "../../../custom_components/components/newsletter_block"
import { submitForm } from "./newsletterFormBlockApi"
import { allFields, Field, genderLabels, genderValues, initialState, NewsletterFormBlockState, NewsletterId, newsletterLabel, newsletterName, newslettersId, setFieldOnState, setVisited, toggleNewsletterOnState, validateFields, validateFormData } from "./newsletterFormBlockState"
import debounce = require("lodash.debounce")

export class NewsletterForm extends React.Component<NewsletterFormBlockProps, NewsletterFormBlockState> {

  constructor(props: NewsletterFormBlockProps) {
    super(props)

    this.state = initialState
  }

  validate = validateFormData(this.setState.bind(this))
  validateVisitedAfterDelay = debounce(() => this.validate(), 1000)

  submit() {
    const validationMessages = validateFields(allFields, this.state.data)
    if (validationMessages.count() > 0) {
      this.setState((prevState) => ({ ...prevState, validationMessages }))
      return
    }

    this.setState(
      (prevState) => ({ ...prevState, status: 'submitting' }),
      async () => {
        const response = await submitForm(this.state.data)
        if (response.kind == 'result') trackNewsletterSubscription()

        // Handle failed request
        if (response.kind == 'failedWithMessage') {
          var message = response.message
          console.error(response.message)
          this.setState((s0) => ({ ...s0, errorMessage: message }))
        }

        this.setState((prevState) => ({ ...prevState, status: response.kind == 'result'? 'succeeded' : 'failed' }))
      }
    )
  }

  maybeShowMessage(field: Field): JSX.Element {
    const messages = this.state.validationMessages
    return messages.has(field) ? <p className="form__description form__error">{messages.get(field)}</p> : <></>
  }

  render() {
    if (this.state.status == 'submitting') return submitting
    if (this.state.status == 'succeeded') return succeeded
    if (this.state.status == 'failed') return <>{failed(this.state.errorMessage)}</>

    const setField = setFieldOnState(this.setState.bind(this))
    const set = (field: Field) => (e: React.ChangeEvent<HTMLInputElement>) => {
      setField(field)(e.target.value)
      this.validateVisitedAfterDelay()
    }

    const toggler = toggleNewsletterOnState(this.setState.bind(this))
    const toggleNewsletter = (newsletter: NewsletterId) => {
      toggler(newsletter)
      this.validateVisitedAfterDelay()
    }

    const setVisit = setVisited(this.setState.bind(this))
    const visit = (field: Field) => () => setVisit(field)

    const { firstName,lastName, emailAddress, gender, newsletters: selectedNewsletters } = this.state.data
    const canSubmit = this.state.validationMessages.size == 0

    return <Block>
      <div className="newsletter-form container--sg align--center">
        <div className="align--center">
          <fieldset>
            <legend className="form__title title--l container--xs">Persoonlijke informatie</legend>
            <div className="container--s">
              <div className="form__group form__group--name">
                <div className="form__field">
                  <label className="form__label search__label form__label--required" htmlFor="emailAddress">E-mailadres</label>
                  <input className="form__input" name="emailAddress" type="email"
                    onFocus={visit('emailAddress')}
                    onChange={set('emailAddress')}
                    value={emailAddress}
                  />
                  {this.maybeShowMessage('emailAddress')}
                </div>
                <div className="form__field form__field--long">
                  <label className="form__label search__label" htmlFor="firstName">Voornaam</label>
                  <input className="form__input" name="firstName" type="text"
                    onFocus={visit('firstName')}
                    onChange={set('firstName')}
                    value={firstName} />
                  {this.maybeShowMessage('firstName')}
                </div>
                <div className="form__field form__field--long">
                  <label className="form__label search__label form__label--required" htmlFor="lastName">Achternaam</label>
                  <input className="form__input" name="lastName" type="text"
                    onFocus={visit('lastName')}
                    onChange={set('lastName')}
                    value={lastName} />
                  {this.maybeShowMessage('lastName')}
                </div>
              </div>
              <div className="form__field">
                <label className="form__label search__label" htmlFor="gender">Geslacht</label>
                {genderValues.map(g => <div className="form__radio" key={g}>
                  <input className="form__input--radio" type="radio" name="gender" value={g} checked={gender == g} onChange={() => setField('gender')(g)} />
                  <label className="form__label--radio" htmlFor={g} onClick={() => setField('gender')(g)}>{genderLabels[g]}</label>
                </div>)}
              </div>
              <div className="form__field">
                <label className="form__label search__label form__label--required">Ik wil me inschrijven voor de</label>
                {newslettersId.map(newsletter => 
                <div className="form__checkbox" key={newsletterName[newsletter]}>
                  <input className="form__input--checkbox" type="checkbox" name={newsletterName[newsletter]} value={newsletterName[newsletter]}
                    checked={selectedNewsletters.includes(newsletter)}
                    onChange={() => toggleNewsletter(newsletter)}
                  />
                  <label className="form__label--checkbox" htmlFor={"nieuwsLetter"}
                    onClick={() => toggleNewsletter(newsletter)}
                  >{newsletterName[newsletter]}</label>
                  <p className="form__description">{newsletterLabel[newsletter]}</p>
                </div>
                )}
                {this.maybeShowMessage('newsletters')}
              </div>
            </div>
          </fieldset>

          <button
            className="button button--primary"
            disabled={!canSubmit}
            onMouseOver={() => this.validate(true)}
            onClick={() => this.submit()}
          >
            Verstuur
          </button>
        </div>
      </div>
    </Block>
  }
}

const submitting = <Block><div className="newsletter-form newsletter-form--submitting container--lg align--center">
  <div className="container--m align--center">
    <h2 className="form__title title--l container--xs">Bezig met versturen</h2>
    <Loader />
  </div>
</div></Block>

const succeeded = <Block><div className="newsletter-form newsletter-form--succeeded container--lg align--center">
  <div className="container--m align--center">
    <h2 className="form__title title--l container--xs">Inschrijving verstuurd</h2>
    <div className="container--s text--styled">
      <p>
        Bedankt voor het aanmelden voor de nieuwsbrief! We hebben je gegevens verwerkt zodat je de nieuwsbrief binnenkort ontvangt.
      </p>
    </div>
  </div>
</div></Block>

const failed = (errorMessage: string) => <Block><div className="newsletter-form newsletter-form--failed container--lg align--center">
  <div className="container--m align--center">
    <h2 className="form__title title--l container--xs">Het inschrijven is mislukt</h2>
    <div className="container--s text--styled">
      <p>
        Er is iets misgegaan tijdens het aanmelden voor de nieuwsbrief. Herlaadt deze pagina en probeer het nog eens.
      </p>
      <p className="form_error_message">
        {errorMessage}
      </p>
      <p>
        Lukt het nog steeds niet? Neem dan <Link url="/klantenservice">contact</Link> met ons op.
      </p>
    </div>
  </div>
</div></Block>

